/* Sei Brava theme */
(function () {
  'use strict';
  var S = window.sb || {};
  var STR = S.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var HEART = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.3a4.3 4.3 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20Z"/></svg>';

  function money(cents) {
    try { return new Intl.NumberFormat(S.locale || undefined, { style: 'currency', currency: S.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + (S.currency || ''); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }
  var toastT;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(toastT);
    toastT = setTimeout(function () { t.hidden = true; }, 2800);
  }

  /* ---------- drawers ---------- */
  var overlay = $('[data-overlay]');
  function closeAll() {
    $$('.drawer').forEach(function (d) { d.hidden = true; });
    var sp = $('#SearchPanel'); if (sp) sp.hidden = true;
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('is-locked');
  }
  function openDrawer(id) {
    var el = document.getElementById(id); if (!el) return;
    if (id === 'SearchPanel') {
      var wasHidden = el.hidden; closeAll(); el.hidden = !wasHidden;
      if (!el.hidden) { var i = $('[data-search-input]', el); if (i) i.focus(); }
      return;
    }
    closeAll(); el.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.classList.add('is-locked');
  }
  var menuDrawer = document.getElementById('MenuDrawer');
  if (menuDrawer) document.body.appendChild(menuDrawer);

  /* ---------- cart ---------- */
  function updateCount() {
    return fetch(S.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    }).catch(function () {});
  }
  function refreshCart() {
    return fetch(S.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
      var n = $('[data-cart-inner]', doc), cur = $('[data-cart-inner]');
      if (n && cur) cur.innerHTML = n.innerHTML;
      return updateCount();
    });
  }
  function postAdd(body, isJson) {
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, body: body };
    if (isJson) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(S.cartAdd + '.js', opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || STR.error);
        return j;
      });
    });
  }
  function afterAdd() { return refreshCart().then(function () { openDrawer('CartDrawer'); }); }

  /* ---------- wishlist ---------- */
  var WKEY = 'sb_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function setWl(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} syncWl(); }
  function syncWl() {
    var a = wl();
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', a.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = a.length; c.hidden = !a.length; });
  }
  function renderWishlistPage() {
    var g = $('[data-wishlist-grid]'); if (!g) return;
    var a = wl(), empty = $('[data-wishlist-empty]'), cta = $('[data-wishlist-cta]');
    if (!a.length) { g.innerHTML = ''; empty.hidden = false; cta.hidden = false; return; }
    empty.hidden = true; cta.hidden = true;
    Promise.all(a.map(function (h) {
      return fetch(S.root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      g.innerHTML = list.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var url = S.root + 'products/' + p.handle;
        return '<div><article class="card"><div class="card__media"><div class="card__images">' + (img ? '<img class="card__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div><a class="card__link" href="' + esc(url) + '" aria-label="' + esc(p.title) + '"></a><button type="button" class="wish" data-wish="' + esc(p.handle) + '" aria-pressed="true">' + HEART + '</button></div><div class="card__info"><h3 class="card__title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3><div class="price"><span class="price__now">' + money(p.price) + '</span></div></div></article></div>';
      }).join('');
      syncWl();
    });
  }

  /* ---------- global clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open')); return; }
    if (t.closest('[data-close]') || t === overlay) { closeAll(); return; }

    var w = t.closest('[data-wish]');
    if (w) {
      e.preventDefault();
      var h = w.getAttribute('data-wish'), a = wl(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.push(h);
      setWl(a);
      if ($('[data-wishlist-grid]')) renderWishlistPage();
      return;
    }
    var q = t.closest('[data-qty]');
    if (q) {
      q.disabled = true;
      fetch(S.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.getAttribute('data-qty'), quantity: +q.getAttribute('data-to') }) })
        .then(refreshCart).catch(function () { toast(STR.error); });
      return;
    }
    var qa = t.closest('[data-quick-add]');
    if (qa) {
      qa.disabled = true;
      postAdd({ items: [{ id: +qa.getAttribute('data-quick-add'), quantity: 1 }] }, true)
        .then(afterAdd).catch(function (err) { toast(err.message); }).then(function () { qa.disabled = false; });
      return;
    }
    var st = t.closest('[data-qty-step]');
    if (st) {
      var inp = $('input', st.parentNode);
      inp.value = Math.max(1, (+inp.value || 1) + (+st.getAttribute('data-qty-step')));
      return;
    }
    var car = t.closest('[data-carousel-prev],[data-carousel-next]');
    if (car) {
      var tr = $('[data-carousel-track]', car.closest('[data-carousel]'));
      tr.scrollBy({ left: (car.hasAttribute('data-carousel-next') ? 1 : -1) * tr.clientWidth * 0.8, behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); var lb = $('[data-lightbox]'); if (lb) { lb.hidden = true; document.body.classList.remove('is-locked'); } }
  });

  /* ---------- announcement ---------- */
  var msgs = $$('.announce__msg');
  if (msgs.length > 1) {
    var mi = 0;
    setInterval(function () {
      msgs[mi].classList.remove('is-active'); mi = (mi + 1) % msgs.length; msgs[mi].classList.add('is-active');
    }, 4200);
  }

  /* ---------- selects that auto-submit ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-auto-submit]');
    if (s && s.form) s.form.submit();
  });

  /* ---------- predictive search ---------- */
  var si = $('[data-search-input]'), sr = $('[data-search-results]'), stt;
  if (si && sr) {
    si.addEventListener('input', function () {
      clearTimeout(stt);
      var q = si.value.trim();
      if (q.length < 2) { sr.innerHTML = ''; return; }
      stt = setTimeout(function () {
        fetch(S.searchSuggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var d = new DOMParser().parseFromString(html, 'text/html');
            var sec = $('.shopify-section', d) || d.body;
            sr.innerHTML = sec.innerHTML; syncWl();
          }).catch(function () {});
      }, 250);
    });
  }

  /* ---------- recommendations ---------- */
  function initRecs() {
    $$('[data-recs]').forEach(function (el) {
      var u = el.getAttribute('data-url');
      if (!u || el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '1');
      fetch(u).then(function (r) { return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var n = $('[data-recs]', d);
        if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; syncWl(); }
      }).catch(function () {});
    });
  }

  /* ---------- product page ---------- */
  function initProduct(sec) {
    if (sec.getAttribute('data-ready')) return; sec.setAttribute('data-ready', '1');
    var vj = $('[data-variants]', sec), variants = vj ? JSON.parse(vj.textContent) : [];
    var idInput = $('[data-variant-id]', sec), priceEl = $('[data-price]', sec), compEl = $('[data-compare]', sec);
    var addBtn = $('[data-add]', sec), addLabel = $('[data-add-label]', sec), form = $('.buy', sec);
    var sticky = $('[data-sticky-atc]', sec), stickyBtn = $('[data-add-sticky]', sec), stickyPrice = $('[data-sticky-price]', sec);
    var slider = $('[data-slider]', sec);
    var title = ($('.pdp__title', sec) || {}).textContent || document.title;
    var current = null;
    function byId(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
    current = idInput ? byId(idInput.value) : variants[0];
    var charms = null;

    function renderPrice() {
      if (!current) return;
      var extra = charms ? charms.extraCost() : 0;
      var total = current.price + extra;
      if (priceEl) priceEl.textContent = money(total);
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (compEl) {
        var show = current.compare_at_price && current.compare_at_price > current.price && !extra;
        compEl.hidden = !show; if (show) compEl.textContent = money(current.compare_at_price);
      }
      var wrap = $('[data-price-wrap]', sec);
      if (wrap) wrap.classList.toggle('price--sale', !!(current.compare_at_price > current.price));
    }
    function setAvail() {
      var ok = current && current.available;
      [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !ok; });
      if (idInput) idInput.disabled = !ok;
      var label = ok ? STR.add : STR.soldOut;
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) stickyBtn.textContent = label;
    }
    function goToMedia(id) {
      var slide = $('[data-media-id="' + id + '"]', sec); if (!slide || !slider) return;
      slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      markThumb(id);
    }
    function markThumb(id) { $$('.thumb', sec).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-thumb') === String(id)); }); }

    $$('.option', sec).forEach(function (fs) {
      fs.addEventListener('change', function () {
        var sel = $$('.option', sec).map(function (o) { var c = $('input:checked', o); return c ? c.value : null; });
        $$('.option', sec).forEach(function (o) { var c = $('input:checked', o), l = $('[data-option-label]', o); if (c && l) l.textContent = c.value; });
        var found = null;
        variants.forEach(function (v) { if (!found && v.options.every(function (x, i) { return x === sel[i]; })) found = v; });
        if (!found) { current = null; if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = STR.unavailable; return; }
        current = found; if (idInput) idInput.value = found.id;
        setAvail(); renderPrice();
        if (charms && charms.syncLimit) charms.syncLimit();
        if (found.featured_media) goToMedia(found.featured_media.id);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', found.id); window.history.replaceState({}, '', u); } catch (e) {}
      });
    });

    /* gallery */
    if (slider) {
      var sct;
      slider.addEventListener('scroll', function () {
        clearTimeout(sct);
        sct = setTimeout(function () {
          var slides = $$('.slide', slider), i = Math.round(slider.scrollLeft / (slider.clientWidth || 1));
          if (slides[i]) markThumb(slides[i].getAttribute('data-media-id'));
        }, 80);
      });
    }
    sec.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (th) { goToMedia(th.getAttribute('data-thumb')); return; }
      var z = e.target.closest('[data-zoom]');
      if (z) {
        var lb = $('[data-lightbox]'), im = $('[data-lightbox-img]');
        if (lb && im) { im.src = z.getAttribute('data-zoom'); lb.classList.remove('is-zoomed'); lb.hidden = false; document.body.classList.add('is-locked'); }
        return;
      }
      var tab = e.target.closest('[data-tab]');
      if (tab) showTab(tab.getAttribute('data-tab'));
    });
    function showTab(name) {
      $$('[data-tab]', sec).forEach(function (b) { var on = b.getAttribute('data-tab') === name; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
      $$('[data-panel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== name; });
    }

    /* charms */
    var box = $('[data-charms]', sec);
    if (box) {
      var data = JSON.parse(($('[data-charms-data]', box) || { textContent: '[]' }).textContent), map = {};
      data.forEach(function (c) { map[String(c.id)] = c; });
      var label = box.getAttribute('data-prop-label') || 'Charm';
      var included = +box.getAttribute('data-included') || 0, max = +box.getAttribute('data-max') || 5, need = box.getAttribute('data-require') === 'true';
      var selected = [], activeCat = '', query = '';
      var stage = $('[data-cstage-charms]', sec), stageEmpty = $('[data-cstage-empty]', sec), msg = $('[data-charm-msg]', box);
      var tilesWrap = $('[data-charm-tiles]', box), chosen = $('[data-charm-selected]', box), countChip = $('[data-charm-count]', box);
      var update = function () {
        $$('.ctile', box).forEach(function (t) { t.classList.toggle('is-selected', selected.indexOf(t.getAttribute('data-charm')) > -1); });
        countChip.textContent = selected.length + '/' + max;
        chosen.innerHTML = selected.map(function (id, i) { return '<span class="chip">' + esc(map[id].title) + '<button type="button" data-charm-remove="' + i + '" aria-label="x">&times;</button></span>'; }).join('');
        var w = Math.min(30, 92 / Math.max(selected.length, 1));
        stage.innerHTML = selected.map(function (id) { var c = map[id]; return '<div class="cstage__charm" style="flex:0 1 ' + w + '%">' + (c.image ? '<img src="' + esc(c.image) + '" alt="">' : '') + '<span>' + esc(c.title) + '</span></div>'; }).join('');
        if (stageEmpty) stageEmpty.hidden = selected.length > 0;
        msg.hidden = true; renderPrice();
      };
      var filter = function () {
        $$('.ctile', box).forEach(function (t) {
          var okQ = !query || t.getAttribute('data-title').indexOf(query) > -1;
          var okC = !activeCat || (t.getAttribute('data-cats') || '').split('|').indexOf(activeCat) > -1;
          t.hidden = !(okQ && okC);
        });
      };
      box.addEventListener('click', function (e) {
        var t = e.target.closest('.ctile');
        if (t) {
          var id = t.getAttribute('data-charm'), i = selected.indexOf(id);
          if (i > -1) selected.splice(i, 1);
          else { if (selected.length >= max) { countChip.textContent = max + '/' + max; return; } selected.push(id); if ($('[data-tab]', sec)) showTab('custom'); }
          update(); return;
        }
        var r = e.target.closest('[data-charm-remove]');
        if (r) { selected.splice(+r.getAttribute('data-charm-remove'), 1); update(); return; }
        var c = e.target.closest('[data-cat]');
        if (c) { activeCat = c.getAttribute('data-cat'); $$('[data-cat]', box).forEach(function (b) { b.classList.toggle('is-active', b === c); }); filter(); }
      });
      var si2 = $('[data-charm-search]', box);
      if (si2) si2.addEventListener('input', function () { query = si2.value.trim().toLowerCase(); filter(); });
      var syncLimit = function () {
        var n = null;
        $$('.option', sec).forEach(function (o) {
          var lg = ($('legend', o) || {}).textContent || '';
          if (/letra|letter|lettere|charm/i.test(lg)) {
            var c = $('input:checked', o), m = c && c.value.match(/\d+/);
            if (m) n = +m[0];
          }
        });
        if (n) { max = n; included = n; if (selected.length > n) selected.length = n; update(); }
      };
      var msgTpl = box.getAttribute('data-mode') === 'letters' ? STR.chooseLetters : STR.chooseCharms;
      charms = {
        syncLimit: syncLimit,
        msgTpl: msgTpl,
        extraCost: function () { return selected.slice(included).reduce(function (s, id) { return s + map[id].price; }, 0); },
        ready: function () { return !need || selected.length >= included; },
        missing: function () { return included - selected.length; },
        props: function () { var p = {}; selected.forEach(function (id, i) { p[label + ' ' + (i + 1)] = map[id].title; }); return p; },
        extras: function () { return selected.slice(included).map(function (id) { return map[id].variant; }).filter(Boolean); },
        showMsg: function (m) { msg.textContent = m; msg.hidden = false; }
      };
      syncLimit();
      update();
    }

    /* add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        var qtyEl = $('input[name="quantity"]', sec), qty = qtyEl ? Math.max(1, +qtyEl.value || 1) : 1, req;
        if (charms) {
          if (!charms.ready()) { charms.showMsg((charms.msgTpl || '').replace('__N__', charms.missing())); return; }
          var items = [{ id: +idInput.value, quantity: qty, properties: charms.props() }];
          charms.extras().forEach(function (vid) { items.push({ id: vid, quantity: qty, properties: { _para: title.trim() } }); });
          req = postAdd({ items: items }, true);
        } else {
          var fd = new FormData(form); if (qtyEl) fd.set('quantity', qty);
          req = postAdd(fd, false);
        }
        [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = true; });
        req.then(afterAdd).catch(function (err) { toast(err.message || STR.error); }).then(setAvail);
      });
    }

    /* sticky bar */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
      }).observe(addBtn);
    }
    renderPrice();
  }

  var lb = $('[data-lightbox]');
  if (lb) lb.addEventListener('click', function (e) {
    if (e.target.closest('[data-lightbox-close]')) { lb.hidden = true; document.body.classList.remove('is-locked'); return; }
    if (e.target.tagName === 'IMG') lb.classList.toggle('is-zoomed'); else { lb.hidden = true; document.body.classList.remove('is-locked'); }
  });

  function init() {
    $$('[data-product-section]').forEach(initProduct);
    initRecs(); syncWl(); renderWishlistPage();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
